export default "__VITE_ASSET__41f4b5d7__"